import { createReducer } from 'Helpers/redux'
import {
  GET_ARTISTS,
  GET_CURATORS,
  SEARCH_USERS,
  BLOCK_CURATOR,
  CHANGE_CURATOR_AUTOPAY,
  GET_AUTOPAY_CURATORS,
  GET_SELECTED_CURATOR,
  CHANGE_CURATOR_VALIDATION,
} from '../actions/usersActions'

const initialState = {
  artists: [],
  curators: [],
  selectedCurator: {},
  autopayCurators: [],
  usersCount: {
    totalUsers: 0,
    totalCurators: 0,
    totalArtists: 0,
    totalAutopayCurators: 0,
  },
  foundUsers: [],
}

const handlers = {
  [GET_CURATORS.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    curators: payload.curators,
    usersCount: payload.usersCount,
  }),
  [GET_ARTISTS.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    artists: payload.artists,
    usersCount: payload.usersCount,
  }),
  [SEARCH_USERS.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    foundUsers: payload.users,
  }),

  [BLOCK_CURATOR.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    curators: [
      ...prevState.curators.map(curator =>
        curator.id === payload.id ? payload : curator
      ),
    ],
    foundUsers: prevState.foundUsers.map(user =>
      user.id === payload.id ? { ...user, is_blocked: true } : user
    ),
  }),

  [CHANGE_CURATOR_AUTOPAY.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    curators: prevState.curators.map(curator =>
      curator.id === payload.curator_id
        ? { ...curator, autopay: payload.autopay }
        : curator
    ),
    selectedCurator:
      prevState.selectedCurator.id === payload.curator_id
        ? { ...prevState.selectedCurator, autopay: payload.autopay }
        : prevState.selectedCurator,
  }),
  [GET_AUTOPAY_CURATORS.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    autopayCurators: payload.curators,
    usersCount: payload.usersCount,
  }),
  [GET_SELECTED_CURATOR.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    selectedCurator: payload,
  }),

  [CHANGE_CURATOR_VALIDATION.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    curators: [
      ...prevState.curators.map(curator =>
        curator.id === payload.id ? payload : curator
      ),
    ],
    foundUsers: [
      ...prevState.foundUsers.map(curator =>
        curator.id === payload.id ? payload : curator
      ),
    ],
  }),
}

export default createReducer(initialState, handlers)
